import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import { ParentComplaintsIndex, ParentComplaintsDetails } from './routes';

const ParentComplaintLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'ParentComplaint' */ './components/ParentComplaints'
		)
);

export default (store) => {
	return [
		{
			path: 'home/parent-complaints',
			element: (
				<AsyncLoading
					component={
						<ParentComplaintLazy
							featureFlag="FeatureFlag:ParentComplaints"
							permission="CanViewParentComplaints"
						/>
					}
				/>
			),
			children: [ParentComplaintsIndex(store), ParentComplaintsDetails(store)],
		},
	];
};
